module.exports = __webpack_public_path__ + "img/Sead Kolasinac.6ff470a5.png";